import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import background from '../../images/congruent_outline.png'

function SiteFooter(props){
  const style = {backgroundImage: 'url('+background+')',
  backgroundRepeat: 'repeat'};

  return (
    <footer style={style} id="SiteFooter">
      <h3>© 2017 Zak Risha</h3>
      <h3>All poems used are in the public domain.</h3>
    </footer>
  )
}

export default SiteFooter;



// WEBPACK FOOTER //
// ./src/components/Site/SiteFooter.js